import type { TextareaHTMLAttributes } from "react";
import { cx } from "./cx";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

/** Multiline field — the NL prompt input (M5) composes from this. */
export function Textarea({ error = false, className, rows = 3, ...rest }: TextareaProps) {
  return (
    <textarea
      className={cx("pz-input", error && "pz-input--error", className)}
      aria-invalid={error || undefined}
      rows={rows}
      {...rest}
    />
  );
}
